import { render, staticRenderFns } from "./serviceCustom.vue?vue&type=template&id=3afca01a&scoped=true&"
import script from "./serviceCustom.vue?vue&type=script&lang=js&"
export * from "./serviceCustom.vue?vue&type=script&lang=js&"
import style0 from "./serviceCustom.vue?vue&type=style&index=0&id=3afca01a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afca01a",
  null
  
)

component.options.__file = "serviceCustom.vue"
export default component.exports